// AlertUtilities.js

export const getAlertType = (alertId) => {
    if (!alertId) return null;

    const firstChar = alertId.charAt(0).toLowerCase();
    switch (firstChar) {
        case 'h':
            return 'Health & Safety';
        case 't':
            return 'Thermal Comfort';
        case 'r':
            return 'Resource Efficiency';
        case 's':
            return 'Service Check';
        default:
            return 'Unknown';
    }
};

export const getAlertSeverity = (alertId) => {
    if (!alertId) return null;

    // Handle RE-CHECK alerts - they should have the same impact as the original alert
    if (alertId.endsWith('R')) {
        // Remove the 'R' suffix and get the base alert severity
        const baseAlertId = alertId.slice(0, -1);
        
        // Extract the first number from the base alert ID
        const match = baseAlertId.match(/\d/);
        const firstNumber = match ? parseInt(match[0], 10) : null;
        
        if (firstNumber === null) {
            return 'POTENTIAL';
        } else if (firstNumber === 0) {
            return 'POTENTIAL';
        } else if (firstNumber >= 1 && firstNumber <= 2) {
            return 'HIGH';
        } else if (firstNumber >= 3 && firstNumber <= 5) {
            return 'CRITICAL';
        } else {
            return 'POTENTIAL';
        }
    }

    // Extract the first number after the alphanumerical prefix
    const match = alertId.match(/\d/);
    const firstNumber = match ? parseInt(match[0], 10) : null;
    
    if (firstNumber === null) {
        return 'POTENTIAL';
    } else if (firstNumber === 0) {
        return 'POTENTIAL'; // None maps to POTENTIAL
    } else if (firstNumber >= 1 && firstNumber <= 2) {
        return 'HIGH'; // Low maps to HIGH
    } else if (firstNumber >= 3 && firstNumber <= 5) {
        return 'CRITICAL'; // High maps to CRITICAL
    } else {
        return 'POTENTIAL';
    }
}

export const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);

    // Format options
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
        timeZone: 'America/New_York'
    };

    // Format date
    return new Intl.DateTimeFormat('en-US', options).format(date);
};

// New function to get the latest status update timestamp
export const getLatestStatusTimestamp = (statusHistory) => {
    if (!statusHistory || !Array.isArray(statusHistory) || statusHistory.length === 0) {
        return null;
    }
    
    // Get the most recent status entry (last item in array)
    const latestStatus = statusHistory[statusHistory.length - 1];
    return latestStatus.timestamp;
};